<template>
	<!-- 关于云锦 -->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">关于云锦</p>
				</div>
			</div>
		</van-sticky>
		<div class="aboutYjBanbenhao">
			<img src="../../assets/img/logo.png" alt="" />
			<p>当前版本1.0</p>
			
		</div>
		<div style="position: absolute;bottom: 80px;width: 100%;text-align: center;">本app版权所有西安云卷云书网络科技有限责任公司</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {
			back() {
				this.$router.push('/set')
			}
		}
	}
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #fff;
		height: 100vh;
		overflow-y: scroll;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		.aboutYjBanbenhao{
			text-align: center;
			margin-top: 30%;
			img{
				width: 160px;
			}
			p{
				font-size: 28px;/*px*/
			}
		}
	}

</style>
